import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../../../../../store';
import { Calendar, saveCalendarSelected } from '../../../../../features/calendar/calendar-slice';
import { useEffect } from 'react';
import { AddressRadio, AddressRoot, AddressTitle } from './style';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { formatAddress } from '../../../../../utils/calendar';

interface Props {
  physicalAppointments: Calendar[];
  availability: Record<string, boolean>;
}

const Addresses = ({ physicalAppointments, availability }: Props) => {
  const dispatch = useDispatch();
  const { userId: doctorId } = useParams();
  const {
    calendar: { calendarSelected, calendarsAvailables }
  } = useSelector((state: RootState) => state);

  const renderAddress = (calendar: Calendar) => {
    const [alias, inviteFisicalAddress] = formatAddress(calendar);

    return (
      <Typography component={'p'}>
        <Typography variant="body1B" component={'span'}>
          {alias}:{' '}
        </Typography>
        <Typography variant="body2R" component={'span'}>
          {inviteFisicalAddress}
        </Typography>
      </Typography>
    );
  };

  useEffect(() => {
    const calendarWithAvailability = Object.keys(availability).filter(keyId => availability[keyId] === true);
    if (calendarWithAvailability.length == 1) {
      const calendarId = calendarWithAvailability[0];
      const calendar = calendarsAvailables.find(item => item.id === calendarId);
      if (calendar) dispatch(saveCalendarSelected({ calendar, doctorId }));
    }
  }, [availability]);

  return (
    <Box>
      <AddressTitle variant="body1B">Local disponível nesta data e horário</AddressTitle>
      {physicalAppointments.map(calendar => (
        <AddressRoot
          key={calendar.id}
          className={!availability[calendar.id] ? 'disabled' : ''}
          onClick={() => {
            if (availability[calendar.id]) {
              dispatch(saveCalendarSelected({ calendar, doctorId }));
            }
          }}
        >
          <AddressRadio
            disabled={!availability[calendar.id]}
            checked={calendarSelected && calendarSelected.id === calendar.id ? true : false}
          />
          {renderAddress(calendar)}
        </AddressRoot>
      ))}
    </Box>
  );
};

export default Addresses;
